import React, { useState, useContext, useEffect } from 'react';
import Modal from './index';
import { ModalContext } from '../ModalContext';
import { useForm, } from "react-hook-form"
import API from '../API'
import { AdminAddPublicHolidayFunction, AdminEditPublicHolidayFunction, AdminReloadFunction, } from '../interfaces';
import { AdminPersonsResponse, AdminQueryPublicHoliday, } from '../../../backend/src/api/dto';

type FormValues = {
    name: string
    day: number
    month: number
    fromYear: string
    toYear: string
    func: string
}

function AdminAddPublicHoliday({ item, reload, addFunction, setFunction }: {
    item: AdminQueryPublicHoliday | null,
    reload: AdminReloadFunction,
    addFunction: AdminAddPublicHolidayFunction,
    setFunction: AdminEditPublicHolidayFunction,
}) {

    const [showModal, closeModal] = useContext(ModalContext);
    const { register, control, handleSubmit, getValues, } = useForm<FormValues>({
        defaultValues: item ? {
            name: item.name,
            day: item.day,
            month: item.month,
            fromYear: item.fromYear,
            toYear: item.toYear,
            func: item.function,
        } : {
            name: '',
            day: 1,
            month: 1,
            fromYear: '',
            toYear: '',
            func: 'none',
        }
    })

    const [loading, setLoading] = useState(true);
    const [sending, setSending] = useState(false);
    const [apiResult, setApiResult] = useState<null | { status: boolean }>(null)

    const modalButtons = [
        {
            text: 'Confirm',
            icon: 'check',
            onClick: () => onSubmit(),

            style: 'primary'
        }, {
            text: 'Cancel',
            icon: 'xmark',
            onClick: 'closeModal',
            style: 'secondary'
        }
    ];


    const onSubmit = () => {
        //const form = getValues();
        setSending(true);
        return new Promise((resolve, reject) => {
            handleSubmit((data) => {
                setLoading(false);
                setApiResult({
                    status: true,
                })

                let requestResult
                if (item) {
                    requestResult = setFunction(item.publicHolidayId, data.name, data.day, data.month, data.func, data.fromYear, data.toYear)
                } else {
                    requestResult = addFunction(data.name, data.day, data.month, data.func, data.fromYear, data.toYear)
                }

                requestResult.then(() => {
                    if (reload) {
                        console.log('in reload')
                        reload().then(() => {
                            closeModal(null);
                            resolve(1)
                        })
                    } else {
                        closeModal(null);
                        resolve(1)
                    }
                }).catch((e: any) => {
                    setLoading(false);
                    setApiResult(e)
                    resolve(1)
                })
                setSending(false)
            })()
        })
    }

    return (
        <Modal
            buttons={modalButtons}
            title={item ? 'Upraviť sviatok' : 'Pridať sviatok'}
            errorObject={apiResult}
            disableAllButtons={sending}
        >
            <form style={{ minHeight: '300px' }}>

                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Názov</label>
                    </div>
                    <div className="col-9">
                        <input type="text" {...register("name")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Deň</label>
                    </div>
                    <div className="col-9">
                        <input type="number" {...register("day")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Mesiac</label>
                    </div>
                    <div className="col-9">
                        <input type="number" {...register("month")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Od roku</label>
                    </div>
                    <div className="col-9">
                        <input type="text" {...register("fromYear")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Do roku</label>
                    </div>
                    <div className="col-9">
                        <input type="text" {...register("toYear")} className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-3 mt-1 text-end">
                        <label className="form-label">Funkcia</label>
                    </div>
                    <div className="col-9">
                        <input type="text" {...register("func")} className="form-control form-control-sm" />
                    </div>
                </div>
            </form>
        </Modal>
    )
}

export default AdminAddPublicHoliday
